<template>
  <div class="new-invitation">
    <div class="nav-bar-wrap">
      <div class="nav-bar">
        <p class="title">{{ $t('访客信息登记') }}</p>
      </div>
    </div>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <div class="content">
        <van-form @submit="onConfirm" scroll-to-error ref="form">
          <van-field
            :label="$t('上传免冠照')"
            class="space photo"
            input-align="right"
            name="visitorPhoto"
            :value="form.visitorPhoto"
          >
            <template #input>
              <div class="cropper">
                <div
                  :style="{ backgroundImage: `url('${photo}')` }"
                  class="img"
                />
                <!-- option是配置，格式是对象，getbase64Data是组件的一个方法获取裁剪完的头像 2.14新增一个获取getblobData的方法 -->
                <h5-cropper
                  :option="option"
                  @getFile="getFile"
                  @getbase64Data="getbase64Data"
                />
              </div>
            </template>
          </van-field>
          <van-field
            v-model="form.visitorName"
            name="visitorName"
            :label="$t('领队姓名：')"
            class="space"
            :placeholder="$t('请输入')"
            maxlength="15"
            required
            :rules="[{ required: true, message: $t('请输入领队姓名') }]"
          />
          <van-field
            v-model="form.idCard"
            name="idCard"
            :label="$t('身份证号：')"
            class="space"
            :placeholder="$t('请输入')"
            maxlength="18"
            required
            clearable
            :rules="[
              // 先不校验
              // {
              //   trigger: 'onChange',
              //   validator: validateIdCard,
              //   message: getIdCardMsg,
              // },
            ]"
          />
          <van-field
            v-model="form.visitorMobile"
            name="visitorMobile"
            :label="$t('手机号码：')"
            type="tel"
            class="space"
            :placeholder="$t('请输入')"
            clearable
            :rules="[
              { required: true, message: $t('请输入手机号码') },
              {
                message: $t('请输入正确的手机号码'),
                validator: validatePhone,
                trigger: 'onChange',
              },
            ]"
            required
          />

          <van-field
            v-model="form.visitorCompany"
            name="visitorCompany"
            :label="$t('单位名称：')"
            class="space"
            :placeholder="$t('请输入')"
            clearable
            :rules="[{ required: true, message: $t('请输入单位名称') }]"
            required
          />

          <van-field
            name="date"
            :value="date"
            :label="$t('到访日期：')"
            class="space"
            :placeholder="$t('请选择访问日期')"
            @click="showDate = true"
            readonly
            required
            clickable
            :rules="[{ message: $t('请选择访问日期'), required: true }]"
          />

          <van-calendar
            v-model="showDate"
            @confirm="choseDate"
            :title="$t('日期筛选')"
            color="#009BFF"
            :formatter="formatter"
          />

          <van-field
            :value="form.visitTime"
            name="visitTime"
            :label="$t('到访时间：')"
            class="space"
            readonly
            required
            :rules="timePickerRules"
          >
            <template #input>
              <van-field
                class="clear-field-style"
                clickable
                :value="form.visitTime"
                name="visitTime"
                @click="showTime = true"
              >
                <template #input>
                  <div>{{ visitTime }}</div>
                </template>
              </van-field>
              <div class="time-interval">{{ $t('至') }}</div>
              <van-field
                class="clear-field-style"
                clickable
                :value="form.visitEndTime"
                name="visitEndTime"
                @click="showEndTime = true"
              >
                <template #input>
                  <div>{{ visitEndTime }}</div>
                </template>
              </van-field>
            </template>
          </van-field>

          <van-popup
            v-model="showTime"
            position="bottom"
            closeable
            safe-area-inset-bottom
          >
            <van-datetime-picker
              v-model="visitTime"
              type="time"
              :title="$t('选择时间')"
              :min-hour="0"
              :max-hour="23"
              :show-toolbar="false"
            />
            <div class="time-box">
              <van-button
                round
                block
                type="info"
                native-type="button"
                class="time-btn"
                @click="showTime = false"
                >{{ $t('确认') }}</van-button
              >
            </div>
          </van-popup>

          <van-popup
            v-model="showEndTime"
            position="bottom"
            closeable
            safe-area-inset-bottom
          >
            <van-datetime-picker
              v-model="visitEndTime"
              type="time"
              :title="$t('选择时间')"
              :min-hour="0"
              :max-hour="23"
              :show-toolbar="false"
            />
            <div class="time-box">
              <van-button
                round
                block
                type="info"
                native-type="button"
                class="time-btn"
                @click="
                  () => {
                    showEndTime = false
                    $refs?.form?.validate('visitTime')
                  }
                "
                >{{ $t('确认') }}</van-button
              >
            </div>
          </van-popup>

          <div class="time-notice">
            <img src="@/assets/images/notice.png" alt="" />
            <span
              >{{ $t('注：场馆开放时间9：00至12：00、14：00至17：00；')
              }}<br />{{
                $t('访客请在该时间段内预约签到，其他时候请勿预约。')
              }}</span
            >
          </div>

          <van-field
            :label="$t('到访地址：')"
            class="space"
            readonly
            name="address"
            :value="form.address?.address"
          >
            <template #input>
              <div v-if="addressList.length == 0" :style="{ color: '#c8c9cc' }">
                {{ $t('暂无地址') }}
              </div>
              <div v-else @click="showAddress = true" class="address">
                <span>{{ form.address?.address }}</span>
                <img src="@/assets/images/more.png" alt="" class="icon-more" />
              </div>
            </template>
          </van-field>

          <van-popup
            v-model="showAddress"
            position="bottom"
            safe-area-inset-bottom
          >
            <div>
              <van-radio-group :value="form.address?.id" class="time-list">
                <div>
                  <van-radio
                    :name="item.id"
                    class="time-list-card"
                    icon-size="21px"
                    v-for="item in addressList"
                    :key="item.id"
                    @click="selectAddress(item)"
                  >
                    <div class="time-list-range">
                      {{ item.address }}
                    </div>
                  </van-radio>
                </div>
              </van-radio-group>
            </div>
          </van-popup>

          <van-field
            v-model="form.visitorNumber"
            name="visitorNumber"
            :label="$t('人数：')"
            class="space"
          >
            <template #input>
              <div class="num-box">
                <div class="num">
                  <span>{{ form.visitorNumber }}</span>
                </div>
                <div class="num-control">
                  <div @click="addNum">
                    <img src="@/assets/images/up.png" alt="" />
                  </div>
                  <div @click="reduceNum">
                    <img src="@/assets/images/down.png" alt="" />
                  </div>
                </div>
              </div>
            </template>
          </van-field>
          <div class="agree-box">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              class="agree-btn"
              :loading="submitting"
              :loading-text="$t('提交中...')"
              >{{ $t('提交拜访记录') }}</van-button
            >
          </div>
        </van-form>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import H5Cropper from 'vue-cropper-h5'
Vue.use(H5Cropper)
import { visitorSave, upload, fetchVisitAddress } from './service'
import Vue from 'vue'
import {
  Field,
  Button,
  Form,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Calendar,
  Toast,
  Icon,
  PullRefresh,
} from 'vant'

import { isCNCard, isHKCard } from './validator/idCard'
Vue.use(Icon)
Vue.use(Field)
Vue.use(Button)
Vue.use(Form)
Vue.use(Radio)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Calendar)
Vue.use(PullRefresh)

const inRange = (targe, left, right) => targe >= left && targe <= right

export default {
  name: 'visitorApply',
  components: {},
  data() {
    return {
      form: {
        visitTime: dayjs()?.add(1, 'h')?.format('YYYY-MM-DD HH:00:00'),
        visitEndTime: dayjs()?.add(2, 'h')?.format('YYYY-MM-DD HH:00:00'),
        visitorNumber: 1,
      },

      showTime: false,
      showEndTime: false,
      showDate: false,
      showSelect: true,
      showAddress: false,

      photo: require('@/assets/images/upLoad.png'),

      option: {
        fixedNumber: [9, 16],
        confirmButtonBackgroundColor: '#009BFF',
        outputType: 'jpeg',
        outputSize: 0.7,
        cancelButtonText:this.$t('取消'),
        confirmButtonText:this.$t('确认'),
      },

      uploading: false,
      loading: false,
      submitting: false,

      addressList: [],

      timePickerRules: [
        { required: true, message: this.$t('请选择时间') },
        {
          trigger: 'onChange',
          validator: () =>
            dayjs(this?.form?.visitTime).isBefore(
              dayjs(this?.form?.visitEndTime)
            ),
          message: this.$t('结束时间需大于起始时间'),
        },
        {
          trigger: 'onChange',
          validator: () => dayjs().isBefore(dayjs(this?.form?.visitTime)),
          message: this.$t('到访时间/日期无效'),
        },
        {
          trigger: 'onChange',
          validator: () => {
            const h1 = dayjs(this?.form?.visitTime).hour(),
              h2 = dayjs(this?.form?.visitEndTime).hour()
            return (
              (inRange(h1, 9, 12) || inRange(h1, 14, 17)) &&
              (inRange(h2, 9, 12) || inRange(h2, 14, 17)) &&
              dayjs(this?.form?.visitEndTime).isBefore(
                dayjs(this?.form?.visitEndTime).format('YYYY-MM-DD 17:00:01')
              )
            )
          },
          message: this.$t('不在开放时间'),
        },
      ],
    }
  },
  methods: {
    validateIdCard(value) {
      for (let fn of [isCNCard, isHKCard]) {
        if (fn(value) === true) return true
      }
      return false
    },

    getIdCardMsg(value) {
      for (let fn of [isCNCard, isHKCard]) {
        const res = fn(value)
        if (typeof res === 'string') return res
      }
      return this.$t('检验通过')
    },

    validatePhone(value) {
      return /^1[3-9]\d{9}$/.test(value)
    },
    addNum() {
      this.$set(this.form, 'visitorNumber', +this.form?.visitorNumber + 1)
    },
    reduceNum() {
      if (this.form?.visitorNumber <= 1) return
      this.$set(this.form, 'visitorNumber', +this.form?.visitorNumber - 1)
    },
    choseDate(date) {
      this.$set(this.form, 'date', date)

      // 同时改变到访日期上的日期
      this.$set(
        this?.form,
        'visitTime',
        `${dayjs(date)?.format('YYYY-MM-DD')} ${this.visitTime}:00`
      )

      this.$set(
        this?.form,
        'visitEndTime',
        `${dayjs(date)?.format('YYYY-MM-DD')} ${this.visitEndTime}:00`
      )
      this.showDate = false
    },

    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },

    async onConfirm(values) {
      if (this.uploading) {
        Toast.fail(this.$t('人脸识别照片上传中,请稍等'))
        return
      }

      this.submitting = true
      try {
        const companyId = this.$route.params.companyId
        const companyCode = this.$route.query.companyCode

        const id = await visitorSave({
          developerId: this.$route.params.companyId,
          companyId,
          visitType: 'HLG',
          ...values,
        })
        Toast.success({
          message: this.$t('新建邀约成功'),
          onClose: () => {
            this.$router.replace({
              path: '/visitor/pass',
              query: { id, companyCode },
            })
          },
        })
      } catch (error) {
        this.console.error(error)
        const msg = error.response.data.message
        Toast.fail(this.$t('预约失败{slot1}', { slot1: msg && ': \n' + msg }))
      } finally {
        this.submitting = false
      }
    },

    async getFile(data) {
      const formData = new FormData()
      formData.append('file', data)
      try {
        this.uploading = true
        this.$set(this.form, 'visitorPhoto', await upload(formData))
      } catch (error) {
        this.photo = ''
        Toast.fail(this.$t('照片上传失败! 您需重新上传'))
      } finally {
        this.uploading = false
      }
    },

    getbase64Data(data) {
      this.photo = data
    },

    async onRefresh() {
      setTimeout(() => {
        Toast(this.$t('刷新成功'))
        this.loading = false
      }, 500)
    },

    async fetchAddress() {
      this.addressList = await fetchVisitAddress(this.$route.params.companyId)
      this.$set(this.form, 'address', this.addressList?.[0])
    },

    selectAddress(address) {
      this.$set(this.form, 'address', address)
      this.showAddress = false
    },
  },
  computed: {
    console: () => console,
    date() {
      return dayjs(this?.form?.date)?.format('MM-DD')
    },
    visitTime: {
      get() {
        return dayjs(this?.form?.visitTime)?.format('HH:mm')
      },
      set(v) {
        this.$set(
          this?.form,
          'visitTime',
          `${dayjs(this.form?.date)?.format('YYYY-MM-DD')} ${v}:00`
        )
      },
    },
    visitEndTime: {
      get() {
        return dayjs(this?.form?.visitEndTime)?.format('HH:mm')
      },
      set(v) {
        this.$set(
          this?.form,
          'visitEndTime',
          `${dayjs(this.form?.date)?.format('YYYY-MM-DD')} ${v}:00`
        )
      },
    },
  },
  created() {
    console.log(
      `companyCode:${this.$route.query.companyCode}, companyId:${this.$route.params.companyId}`
    )
    this.fetchAddress()
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.clear-field-style {
  padding: unset;
  font-size: unset;
  flex: 0 0 3rem;
}

.new-invitation {
  height: 100%;
  background: #f6f6f6;

  .content {
    margin-top: 40px;
    overflow: auto;
  }

  .agree-box {
    padding: 24px 0px 35px;

    .agree-btn {
      border: none;
      width: 351px;
      margin: 0px auto;
    }
  }

  /deep/.photo {
    height: 86px;

    .van-uploader__upload {
      height: 64px;
      width: 64px;
    }

    .van-cell__value {
      display: block;
    }

    .van-uploader__preview-image {
      width: 64px;
      height: 64px;
    }
  }

  .num-box {
    width: 88px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #ededed;
    display: flex;

    .num {
      width: 66px;
      line-height: 32px;

      span {
        padding-left: 12px;
      }
    }

    .num-control {
      > div {
        width: 21px;
        height: 15px;
        border: 1px solid #ededed;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
}

.nav-bar-wrap {
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;

  .nav-bar {
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    font-size: 18px;

    .title {
      font-size: 17px;
      font-weight: 500;
    }
  }
}

.space {
  margin-top: 24px;
  font-size: 17px;
  color: #333333;
  height: 56px;
}

/deep/.van-field__label {
  display: flex;
  align-items: center;
}

/deep/.van-cell__value {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.time-box {
  height: 72px;
  background: #f7f7f7;
  padding: 5px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .time-btn {
    height: 44px;
    background: #009bff;
  }
}

/deep/.date-border {
  color: #009bff;
}

/deep/ .van-nav-bar .van-icon {
  color: #000000;
}

.cropper {
  width: 54px;
  height: 66px;
  line-height: 66px;
  /* 切记position: relative一定要有 */
  position: relative;
  overflow: hidden;
  text-align: center;

  .img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  /deep/ .btndiv {
    position: absolute;
    width: 100%;
    top: 40px;
  }
}

.time-interval {
  padding-left: 13px;
  padding-right: 13px;
}

.time-notice {
  display: flex;
  padding-left: 16px;
  margin-top: 6px;

  img {
    height: 16px;
    width: 16px;
  }

  span {
    padding-left: 4px;
    height: 16px;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
  }
}

/deep/.time-list {
  position: relative;
  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  height: 275px;
  padding-top: 5px;
  padding-left: 16px;
  overflow: auto;

  .time-list-card {
    min-height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .time-list-range {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    min-height: 50px;
    color: #000000;
    word-break: break-word;
    word-wrap: break-word;
  }
}

.address {
  display: flex;
  align-items: center;

  span {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-more {
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
}
</style>
